import { AdminModalName, AdminPanelName } from '../../../state';
import {
  loadEventRequest,
  pushAdminModal,
  pushAdminPanel,
} from '../../../actions';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useAdminEventsTableController = (event: {
  eventId: string;
  eventName: string;
}) => {
  const dispatch = useDispatch();

  const onDeleteClick = useCallback(
    () => dispatch(pushAdminModal(AdminModalName.DeleteEvent, event)),
    [event],
  );

  const onEditClick = useCallback(() => {
    dispatch(loadEventRequest(event.eventId));
    dispatch(
      pushAdminPanel(AdminPanelName.Event, {
        eventKey: event.eventId,
      }),
    );
  }, [event.eventId]);

  return { onDeleteClick, onEditClick };
};
